import * as React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { BetupFeedChannelDto, BetupFeedChannelPostDto } from '../../models/dtos/BetupFeedChannelDto';
import ChannelPostCard from '../betupFeed/ChannelPostCard';
import { ChannelPostDialog } from '../betupFeed/BetupFeedChannelDialogs';

/**
 * One channel post on Publishing or the match page: the channel page's own card (texts per language with their
 * widgets, publish, delete) and its editor, so a draft is read, fixed and published without leaving the page.
 */
export default function PublishingPostDialog({ post, channel, onClose, onChanged }: {
    post: BetupFeedChannelPostDto | null;
    /** The post's channel (its languages and logo); null while the channels load. */
    channel: BetupFeedChannelDto | null;
    onClose: () => void;
    /** After a publish, a delete or an edit: the page reloads its list. */
    onChanged: (message: string) => void;
}) {
    const [current, setCurrent] = React.useState<BetupFeedChannelPostDto | null>(post);
    const [editing, setEditing] = React.useState(false);

    React.useEffect(() => { setCurrent(post); setEditing(false); }, [post]);

    return (
        <>
            <Dialog open={post != null} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
                <DialogTitle>Post #{post?.id}</DialogTitle>
                <DialogContent dividers>
                    {!channel && <Alert severity="info">Loading the channel…</Alert>}
                    {current && (
                        <Stack gap={1}>
                            <ChannelPostCard post={current} channel={channel} lang={null} defaultExpanded
                                onEdit={channel ? () => setEditing(true) : null}
                                onChanged={(changed, message) => { setCurrent(changed); onChanged(message); }}
                                onOpenPlayer={() => undefined} />
                        </Stack>
                    )}
                </DialogContent>
                <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
            </Dialog>
            {channel && current && (
                <ChannelPostDialog open={editing} channel={channel} post={current} onClose={() => setEditing(false)}
                    onEditChannel={() => undefined}
                    onSaved={saved => {
                        setEditing(false);
                        if (saved) setCurrent(saved);
                        onChanged('Post saved');
                    }} />
            )}
        </>
    );
}
